export const menuOptionKeys = {
  notifications: 'notifications',
  brandOptions: 'brandOptions',
  account: 'account',
};
